import React from 'react'
import dayjs from 'dayjs'
import { DatePicker as MuiDatePicker } from '@mui/x-date-pickers'

/**
 * In-line date picker component. Inputs/outputs are all time strings formatted YYYY-MM-DD.
 */
const DatePicker = ({ date, onChange }: Props) => (
  <MuiDatePicker
    onChange={(date) => onChange(date?.format('YYYY-MM-DD') || '')}
    value={dayjs(date)}
  />
)

type Props = {
  date: string
  onChange: (date: string) => void
}

export default DatePicker
